export function getOktaSession(oktaUrl) {
    return fetch(getOktaSessionUrl(oktaUrl), { method: 'GET', credentials: 'include' }).then((response) => {
        if (response.ok) {
            return response.json();
        }
        else {
            return Promise.reject(response.status);
        }
    });
}
export function logOutOfOkta(oktaUrl) {
    return fetch(getOktaSessionUrl(oktaUrl), { method: 'DELETE', credentials: 'include' })
        .then(() => undefined)
        .catch(() => undefined);
}
export function getOktaForgotPasswordUrl(oktaUrl) {
    if (oktaUrl && !oktaUrl.endsWith('/')) {
        oktaUrl += '/';
    }
    return oktaUrl + 'signin/forgot-password';
}
function getOktaSessionUrl(oktaUrl) {
    if (oktaUrl && !oktaUrl.endsWith('/')) {
        oktaUrl += '/';
    }
    return oktaUrl + 'api/v1/sessions/me';
}
